import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfDigitalWorkingHoursScoreAveragesSummaryApplicationService } from '../../../core/application/services/scores/get-self-digital-working-hours-score-averages-summary.application-service';
import { SelfDigitalWorkingHoursScoreAveragesSummaryEntity } from '../../../core/domain/entities/scores/self-digital-working-hours-score-averages-summary.entity';
import { GetSelfScoreAveragesSummaryRequestDto } from '../../dtos/scores/self-get-score-averages-summary.request.dto';

export class GetSelfDigitalWorkingHoursScoreAveragesSummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfDigitalWorkingHoursScoreAveragesSummaryApplicationService
  ) {}
  async execute(
    props: GetSelfScoreAveragesSummaryRequestDto
  ): Promise<SelfDigitalWorkingHoursScoreAveragesSummaryEntity> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
